import { FormGroup } from '@angular/forms';
import { createPersonForm } from '@base/factories/person-form.factory';
import { createPaymentForm } from '@base/factories/payment-form.factory';
import { BikeProductFormModel, createBikeProductForm } from './bike-product-form.factory';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { PaymentFormModel } from '@base/models/form/payment-form.model';
import { BikeLegalCheckFormModel, createLegalCheckForm } from './bike-legal-check-form.factory';

export function createBikeForm(): FormGroup<BikeFormModel> {
  return new FormGroup<BikeFormModel>({
    person: createPersonForm(),
    product: createBikeProductForm(),
    payment: createPaymentForm(),
    legalCheck: createLegalCheckForm()
  });
}

export interface BikeFormModel {
  person: FormGroup<PersonFormModel>;
  product: FormGroup<BikeProductFormModel>;
  payment: FormGroup<PaymentFormModel>;
  legalCheck: FormGroup<BikeLegalCheckFormModel>;
}

